module.exports = __webpack_public_path__ + "654eb17113113ac2528c85db56824770.jpg";